<template>
  <div class="question-box-container">


  

    <b-jumbotron>

      <template slot="lead">
        Pick a category
      </template>

      Each quiz session has 10 questions with multiple answers.

      <hr class="my-4" />

      <b-row no-gutters>
        <b-col xs="6">
          <b-overlay :show="showAnimalOverlay" rounded="sm">
            <b-card 
              @click="start('animals'); showAnimalOverlay = true"
              title="Animals"
              img-src="https://www.shareicon.net/data/2016/08/18/813666_cat_512x512.png"
              img-alt="Image"
              img-top
              tag="article"
              style="max-width: 20rem;"
              class="mb-2"
            >
            </b-card>
          </b-overlay>
        </b-col>
        <b-col xs="6">
          <b-overlay :show="showBookOverlay" rounded="sm">
            <b-card
              @click="start('books'); showBookOverlay = true"
              title="Books"
              img-src="https://icon-library.com/images/flat-icon-library/flat-icon-library-16.jpg"
              img-alt="Image"
              img-top
              tag="article"
              style="max-width: 20rem;"
              class="mb-2"
            >
            </b-card>
          </b-overlay>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col xs="6">
          <b-overlay :show="showGeoOverlay" rounded="sm">
            <b-card
              @click="start('geography'); showGeoOverlay = true"
              title="Geography"
              img-src="https://www.freepngimg.com/thumb/map/66960-maps-google-computer-icons-free-png-hq.png"
              img-alt="Image"
              img-top
              tag="article"
              style="max-width: 20rem;"
              class="mb-2"
            >
            </b-card>
          </b-overlay>
        </b-col>
        <b-col xs="6">
          <b-overlay :show="showSportOverlay" rounded="sm">
            <b-card
              @click="start('sports'); showSportOverlay = true"
              title="Sports"
              img-src="https://image.flaticon.com/icons/png/512/190/190789.png"
              img-alt="Image"
              img-top
              tag="article"
              style="max-width: 20rem;"
              class="mb-2"
            >
            </b-card>
          </b-overlay>
        </b-col>
      </b-row>
    </b-jumbotron>


  </div>
</template>

<script>

export default {
  props: {
    start: Function,
    categorySelected: String,
  },
  data: function() {
    return {
      selectedCategory: null,
      showAnimalOverlay: false,
      showBookOverlay: false,
      showSportOverlay: false,
      showGeoOverlay: false,
    }
  },
  methods: {
    selectCategory(index) {
      this.selectedCategory = index
    },
  }
}
</script>

<style>
.card {
  margin:10px;
  cursor: pointer;
}
.card:hover {
  box-shadow: 10px 10px 20px 0px rgba(12, 50, 100, 0.35);
}

@media only screen and (max-width: 500px) {
  h4 {
    font-size: 1.1rem;
  }
}

</style>